import { StyledTabTitle } from "./styles";

interface CardTitleProps{
  title: string;
}
const CardTitle: React.FC<CardTitleProps> = ({ title = "" }) => {
  return (
    <StyledTabTitle>{title}</StyledTabTitle>
  );
}

export default CardTitle;